import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { McBookieLogo } from 'src/assets/logos/McBookieLogo';
import { McBookieBrandIcon } from 'src/assets/brandIcons/McBookieBrandIcon';

export const McBookieMainLogoWrapper = withConfig(theme => styled('div', { label: 'McBookieMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
    padding-bottom: 16px;
`);

export const McBookieMainLogo = styled(McBookieLogo, { label: 'McBookieMainLogo' })`
    width: 99px;
`;

export const McBookieBrandIconWrapper = styled(McBookieBrandIcon, { label: 'McBookieBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;
